var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfidence(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame 15914"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse 9",
    cx: 28,
    cy: 28,
    r: 25,
    fill: "#6C6C6C",
    stroke: "white",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 13",
    d: "M40.85 36C38.076 39.6361 33.5776 41.9999 28.5001 41.9999C23.4225 41.9999 18.9242 39.6361 16.1501 36",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 48",
    d: "M28 22.5248C27 22.5248 26.0491 22.259 25 21.5246C20 18.0248 12 19.0249 9 19.5249V21.5246C9 21.5246 9.58331 21.8998 10 22.5248C11 24.0248 10 28.5249 12.5 30.5249C15 32.5249 22 32.0249 23.5 31.0249C25 30.0249 25 27.5248 25.5 26.0248C26 24.525 26.9998 24.5249 27.9997 24.5248H28V22.5248Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 49",
    d: "M28 22.5248C29 22.5248 29.9509 22.259 31 21.5246C36 18.0248 44 19.0249 47 19.5249V21.5246C47 21.5246 46.4167 21.8998 46 22.5248C45 24.0248 46 28.5249 43.5 30.5249C41 32.5249 34 32.0249 32.5 31.0249C31 30.0249 31 27.5248 30.5 26.0248C30 24.525 29.0002 24.5249 28.0003 24.5248H28V22.5248Z",
    fill: "white",
    stroke: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 50",
    d: "M12 23.4998C12 22.4998 15.5 22 19 22.4999C22.0108 22.93 24 23.9999 24 24.9999",
    stroke: "#6C6C6C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector 51",
    d: "M44 23.4998C44 22.4998 40.5 22 37 22.4999C33.9892 22.93 32 23.9999 32 24.9999",
    stroke: "#6C6C6C",
    strokeWidth: 2,
    strokeLinecap: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfidence);
export default __webpack_public_path__ + "static/media/Confidence.94b252c2784ff111b40821502e621c12.svg";
export { ForwardRef as ReactComponent };